import { render, staticRenderFns } from "./GenericLogin.vue?vue&type=template&id=4d822f5a&scoped=true"
import script from "./GenericLogin.vue?vue&type=script&lang=js"
export * from "./GenericLogin.vue?vue&type=script&lang=js"
import style0 from "./GenericLogin.vue?vue&type=style&index=0&id=4d822f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d822f5a",
  null
  
)

export default component.exports